var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.$apollo.loading)?_c('div',[_vm._v("result here")]):_c('div',[_c('Loader')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }